import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { AngularFireModule } from 'angularfire2';

import { AppComponent } from './app/app.component';
import { EnterSisUsernameForPasswordResetComponent } from './enter-sis-username-for-password-reset/enter-sis-username-for-password-reset.component';
import { EndpointForPasswordResetComponent } from './endpoint-for-password-reset/endpoint-for-password-reset.component';
import { EnterEmailForForgottenUsernameComponent } from './enter-email-for-forgotten-username/enter-email-for-forgotten-username.component';



const routes: Routes = [
  // Default route sends user to reset password
  {
    path: '',
    redirectTo: '/enter-username-for-password-reset',
    pathMatch: 'full'
  },
  // Reset password
  {
    path: 'enter-username-for-password-reset',
    component: EnterSisUsernameForPasswordResetComponent,
  },
  {
    path: 'endpoint-for-password-reset/:token',
    component: EndpointForPasswordResetComponent,
  },
  // Forgot username
  {
    path: 'enter-email-for-forgotten-username',
    component: EnterEmailForForgottenUsernameComponent,
  },
  // All others get routed to reset password
  {
    path: '**',
    redirectTo: '/enter-username-for-password-reset',
  }
];



const firebaseConfig = {
  apiKey: "AIzaSyC-GIkfgeoHyybOPwVM6kXs7caHnG9MdqM",
  authDomain: "sis-assistant-server.firebaseapp.com",
  databaseURL: "https://sis-assistant-server.firebaseio.com",
  projectId: "sis-assistant-server",
  storageBucket: "sis-assistant-server.appspot.com",
  messagingSenderId: "217815588107"
};



@NgModule({
  declarations: [
    AppComponent,
    EnterSisUsernameForPasswordResetComponent,
    EndpointForPasswordResetComponent,
    EnterEmailForForgottenUsernameComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' }),
    AngularFireModule.initializeApp(firebaseConfig)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
